var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/feed_selected.0b98ed07.png","uri@2x": __webpack_public_path__ + "static/media/feed_selected.406acc7c.png","uri@3x": __webpack_public_path__ + "static/media/feed_selected.55d3e6da.png",
    width: 24,
    height: 25
});